import React from "react";
import * as Yup from 'yup';
import { Comune, CompanyDataDto } from "../../generated"
import { Forms, Divider } from "../../common/components/CmForms";
import EsercentiActions from "../esercentiActions";
import { ComuniAutocomplete } from "../../comuni/components/comuniAutocomplete";
const { Form, FormText, Submit, Cancel, FormCheck } = Forms<NewEsercente>()

interface Props {
    onSubmit: (customer: NewEsercente) => void;
    onCancel: () => void;
}

export class NewEsercente extends CompanyDataDto {
    password: string;
    confirmPassword: string;
    confirmUsername: string;
    nomeTitolare: string;
    comune: Comune | null;
    privacyAccepted: boolean;
    contractAccepted: boolean;
}

export default class EsercenteForm extends React.Component<Props> {

    private static validationSchema = Yup.object<Partial<NewEsercente>>({
        ragioneSocialeEsercente: Yup
            .string()
            .required('Campo obbligatorio'),
        partitaIvaEsercente: Yup
            .string()
            .required('Campo obbligatorio')
            .test("correct", "Valore non valido", value => /^[0-9]{11}$/.test(value))
            .test("exists", "Partita IVA già inserita nel sistema", async value => /^[0-9]{11}$/.test(value) && !await EsercentiActions.esercenteExist(value)),
        codiceFiscaleEsercente: Yup
            .string()
            .required('Campo obbligatorio'),
        indirizzoEsercente: Yup
            .string()
            .required('Campo obbligatorio'),
        cittaEsercente: Yup
            .string()
            .required('Campo obbligatorio'),
        capEsercente: Yup
            .string()
            .required('Campo obbligatorio'),
        provinciaEsercente: Yup
            .string()
            .required('Campo obbligatorio'),
        telMobileEsercente: Yup
            .string()
            .required('Campo obbligatorio'),
        emailEsercente: Yup
            .string()
            .email("deve essere una casella di posta elettronica")
            .required('Campo obbligatorio'),
        confirmUsername: Yup
            .string()
            .email("deve essere una casella di posta elettronica")
            .required('Campo obbligatorio')
            .oneOf([Yup.ref("emailEsercente"), null], 'GLi username non corrispondono'),
        password: Yup
            .string()
            .required(),
        confirmPassword: Yup
            .string()
            .oneOf([Yup.ref("password"), null], 'Le password non corrispondono'),
        nomeTitolare: Yup
            .string()
            .required("campo obbligatorio"),
        pec: Yup
            .string()
            .email("deve essere una casella di posta elettronica")
            .required('Campo obbligatorio'),
        sdi: Yup
            .string()
            .required('Campo obbligatorio'),
        privacyAccepted: Yup
            .bool()
            .required('Per procedere devi accettare la privacy')
            .oneOf([true], 'Per procedere devi accettare la privacy'),
        contractAccepted: Yup
            .bool()
            .required('Per procedere devi accettare il contratto')
            .oneOf([true], 'Per procedere devi accettare il contratto')
    })

    render() {
        const { onCancel } = this.props;

        return (
            <Form
                onSubmit={this.props.onSubmit}
                initialValues={new NewEsercente}
                validationSchema={EsercenteForm.validationSchema}
            >
                {
                    ({ set, values, errors }) =>
                        <>
                            <Divider caption="Dati azienda" />
                            <div className="row">
                                <div className="col-12">
                                    <FormText
                                        label="Ragione sociale:"
                                        name="ragioneSocialeEsercente"
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormText
                                        label="P.IVA:"
                                        name="partitaIvaEsercente"
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormText
                                        label="Codice fiscale:"
                                        name="codiceFiscaleEsercente"
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <ComuniAutocomplete
                                        label="Città"
                                        onChange={async comune => {
                                            await set("comune", comune)
                                            await set("cittaEsercente", comune?.nomeComune)
                                            await set("capEsercente", comune?.cap)
                                            await set("provinciaEsercente", comune?.provincia)
                                        }}
                                        value={values.comune || undefined}
                                        error={errors.cittaEsercente}
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormText
                                        label="Indirizzo:"
                                        name="indirizzoEsercente"
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormText
                                        label="Tel Fisso:"
                                        name="telFissoEsercente"
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormText
                                        label="Tel Mobile:"
                                        name="telMobileEsercente"
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormText
                                        type="email"
                                        name="pec"
                                        label="Pec"
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormText
                                        name="sdi"
                                        label="Codice Univoco"
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormText
                                        label="Link logo:"
                                        name="linkLogoEsercente"
                                    />
                                </div>
                            </div>
                            <Divider caption="Dati account" />
                            <div className="row">
                                <div className="col-12">
                                    <FormText
                                        label="Nome Cognome:"
                                        name="nomeTitolare"
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormText
                                        label="Username:"
                                        name="emailEsercente"
                                    />
                                </div>
                                <div className="col-12 col-md-6">
                                    <FormText
                                        label="Conferma username:"
                                        name="confirmUsername"
                                    />
                                </div>
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-12 col-md-6">
                                            <FormText
                                                label="Password:"
                                                name="password"
                                                type="password"
                                            />
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <FormText
                                                label="Conferma Password"
                                                name="confirmPassword"
                                                type="password"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 d-flex">
                                    <FormCheck
                                        label={<label className="ms-2">Ho letto, compreso e accettato <a className="fw-bold" href="https://www.iubenda.com/termini-e-condizioni/81710242" target="_blank" title="Privacy Policy ">i termini e condizioni</a></label>}
                                        name="contractAccepted"
                                    />
                                </div>
                                <div className="col-12 d-flex">
                                    <FormCheck
                                        label={<label className="ms-2">Dichiaro di aver letto <a className="fw-bold" href="https://www.iubenda.com/privacy-policy/81710242" target="_blank" title="Privacy Policy ">l'informativa privacy</a> e di prestare il consenso al trattamento dei miei dati personali</label>}
                                        name="privacyAccepted"
                                    />
                                </div>
                                <div className="col-12 d-flex align-items-center">
                                    <FormCheck
                                        name="marketingUse"
                                    />
                                    <div className="ms-2">
                                        <div>Iscriviti alla newsletter gratuita</div>
                                        <div><small>Ricevi via email gli aggiornamenti relativi a Caldaie Manager</small></div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-actions mt-3">
                                <Submit alwaysActive>Registrati</Submit>
                                {" "}
                                <Cancel onCancel={onCancel} />
                            </div>
                        </>
                }
            </Form>
        );
    }
}
